import React from "react";
import { IForm } from "../../../../types/form.type";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import { useForm } from "react-hook-form";
import { asyncPostData, asyncPutData } from "../../../../utils/httpRequests";
import ModalForm from "../../modal/ModalForm";
import { Stack } from "@mui/material";
import TextInput from "../../input/TextInput";

const schema = yup.object({
  ten_dt: yup.string().required("Vui lòng nhập tên nhà xe"),
});

function FormDMNHAXE({
  defaultValues,
  isEdit,
  apiCode,
  open,
  onClose,
  setLoad,
}: IForm) {
  const app = useSelector((state: any) => state.app.data);
  const token = useSelector((state: any) => state.auth.token);
  const { showAlert } = useAlertContext();
  const defaultData: { [key: string]: any } = {
    ma_dt: "",
    ten_dt: "",
  };
  const originData = defaultValues || defaultData;

  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({
    mode: "onSubmit",
    defaultValues: originData,
    resolver: yupResolver(schema),
  });

  const handleReset = () => {
    reset(originData);
  };

  const generateDataPost = async (values: typeof defaultData) => {
    const { ma_dt, ten_dt } = values;
    return {
      ten_dt,
      ma_dt: ma_dt || ten_dt,
    };
  };

  const handleSave = async (values: typeof defaultData) => {
    const dataPost: { [key: string]: any } = await generateDataPost(values);
    let resp = null;
    if (isEdit) {
      resp = await asyncPutData({
        id: dataPost._id,
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    } else {
      resp = await asyncPostData({
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    }
    if (resp.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi lưu đối tượng",
      });
    } else {
      onClose();
      setLoad?.((prev: number) => prev + 1);
    }
  };

  const onSubmit = handleSubmit(handleSave);

  return (
    <ModalForm
      formWidth="500px"
      formTitle="nhà xe"
      loading={isSubmitting}
      open={open}
      isEdit={isEdit}
      onClose={onClose}
      onSubmit={onSubmit}
      onReset={handleReset}
    >
      <Stack gap={2}>
        <TextInput
          readOnly={isEdit}
          label="Mã nhà xe"
          labelWidth="30%"
          placeholder="Nhập hoặc tạo tự động"
          name="ma_dt"
          register={register}
        />
        <TextInput
          required
          label="Tên nhà xe"
          labelWidth="30%"
          placeholder="Vui lòng nhập tên nhà xe"
          name="ten_dt"
          register={register}
          errorMessage={errors?.ten_dt?.message as string}
        />
      </Stack>
    </ModalForm>
  );
}

export default FormDMNHAXE;
